
import { Database } from "@/integrations/supabase/types";
import { useCustomRoutineName } from "@/hooks/useCustomNames";
import { EditNameDialog } from "@/components/routines/EditNameDialog";
import Shimmer from "@/components/ui/shimmer";

type Weekday = Database["public"]["Enums"]["weekday"];

interface RoutineInfoProps {
  name: string;
  routineId: string;
  day?: Weekday;
  canEdit?: boolean;
}

export const RoutineInfo = ({ name, routineId, day, canEdit }: RoutineInfoProps) => {
  const { customName, isLoading, updateRoutineName } = useCustomRoutineName(routineId);

  // Usar el nombre actualizado desde la base de datos o el nombre original como fallback
  const displayName = customName || name;

  return (
    <div className="flex items-center gap-2">
      {isLoading ? (
        <Shimmer className="h-7 w-40" />
      ) : (
        <h3 className="text-lg font-semibold ocean:text-white">
          {displayName}
        </h3>
      )}
      {canEdit && !isLoading && (
        <EditNameDialog
          currentName={displayName}
          onSave={updateRoutineName}
          title="Editar nombre de rutina"
        />
      )}
    </div>
  );
};
